<template>
  <div v-if="item">
    <variants :id="id"></variants>
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

import Variants from "@/components/Item/Product/Variants";
export default {
  components: { Variants },
  data: () => ({
    cardLink: "products",
    cardSetLink: "products",
    item: null,
    fields: [
      {
        col: "col-12",
        label: "Название",
        key: "name",
        type: "field",
      },
      {
        col: "col-12",
        label: "Активен",
        key: "is_active",
        type: "checkbox",
      },
      {
        col: "col-12",
        label: "Категории",
        labelKey: "categories",
        key: "categories",
        type: "selects",
        modal: "subcategory",
        selectKey: "name",
      },
      {
        col: "col-12",
        labelKey: "brand",
        label: "Бренд",
        key: "brand",
        type: "select",
        modal: "brand",
        selectKey: "name",
      },
    ],
  }),

  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>